var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10312",
    "data-name": "Group 10312",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.235,
    height: 29.246,
    viewBox: "0 0 30.235 29.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2315",
    "data-name": "Rectangle 2315",
    width: 30.235,
    height: 29.246,
    fill: "#101b2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10311",
    "data-name": "Group 10311",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28398",
    "data-name": "Path 28398",
    d: "M29.95,21.259a.983.983,0,0,0-.691-.287q-.815,0-1.62.036L26.819,8.226a.973.973,0,0,0-.973-.912H24.84L24.647.958a.976.976,0,0,0-.973-.945L20.487,0h-.005a.976.976,0,0,0-.975.975v.975H18.043V.975A.976.976,0,0,0,17.068,0h-3.9a.976.976,0,0,0-.975.975v.975H10.728V.975A.976.976,0,0,0,9.753,0H9.748L6.561.013a.976.976,0,0,0-.973.945L5.395,7.315H4.389a.973.973,0,0,0-.973.919L2.769,19.3c-.592-.021-1.189-.036-1.793-.036A.976.976,0,0,0,0,20.24l.005,8.031a.975.975,0,0,0,.975.975H29.257a.977.977,0,0,0,.975-.975l0-6.324a.974.974,0,0,0-.285-.689M7.508,1.961l1.27-.005v.97a.976.976,0,0,0,.975.975h3.414a.976.976,0,0,0,.975-.975V1.951h1.951v.975a.976.976,0,0,0,.975.975h3.414a.976.976,0,0,0,.975-.975v-.97l1.27.005.163,5.354h-.457a.976.976,0,0,0-.975.975v1.951H18.531V8.29a.976.976,0,0,0-.975-.975H12.679a.976.976,0,0,0-.975.975v1.951H8.778V8.29A.976.976,0,0,0,7.8,7.315H7.345Zm-2.2,7.3H6.827v1.951a.976.976,0,0,0,.975.975h4.877a.976.976,0,0,0,.975-.975V9.265H16.58v1.951a.976.976,0,0,0,.975.975h4.877a.976.976,0,0,0,.975-.975V9.265h1.524l.762,11.884a29.49,29.49,0,0,0-5.7,1.105V20.482a4.873,4.873,0,0,0-9.74-.239,39.308,39.308,0,0,0-5.54-.828ZM17.652,23.138a20.821,20.821,0,0,0-5.46-2.4v-.259a2.926,2.926,0,1,1,5.852,0v2.486c-.132.056-.264.112-.391.17M1.956,27.3l-.005-6.07c9.2.192,15.816,3.126,17.045,6.07Zm26.326,0H21.038a5.8,5.8,0,0,0-1.63-2.748.759.759,0,0,0,.163-.089,27.978,27.978,0,0,1,8.714-1.521Z",
    transform: "translate(0 0)",
    fill: "#101b2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28399",
    "data-name": "Path 28399",
    d: "M7.74,35.25H7.735a.978.978,0,1,0,.005,0m5.852,1.463h-.005a.978.978,0,1,0,.005,0m13.654,1.951a.975.975,0,1,0,0-1.951h-.005a.975.975,0,0,0,.005,1.951",
    transform: "translate(-2.365 -12.33)",
    fill: "#101b2d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon3);
export default __webpack_public_path__ + "static/media/social_icon3.a2e51449caaa28827f08eaf7db1ec35d.svg";
export { ForwardRef as ReactComponent };